import api from './api';

export default {
  applyDiscount: ({ itemId, discountRate }) =>
    api.post(`applyDiscount`, {
      item_id: itemId,
      discount_rate: discountRate,
    }),
};
